// extracted by mini-css-extract-plugin
export var content = "article-module--content--20ea8";
export var inner = "article-module--inner--d5d01";
export var wrapper = "article-module--wrapper--0ac0e";